/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import PackageContent from './PackageContent';
import FreePackageContent from './FreePackageContent';
// import GetCampaign from '../../Api/GetCampaign';
import { useDispatch, useSelector } from 'react-redux';
import { setStoreCampaignListOption } from '../../redux/actions/campaignAction';
import { PACKAGE_MANAGEMENT,CAMPAIGN_APPROVAL_LIST } from '../Shared/constant';
import { GetRequestCallAPI } from '../../Api/GetRequest';
import CommonLogout from '../Common/CommonLogout';

export default function SettingTab() {
    const location = useLocation();
    const { accessToken } = useSelector((state) => state.personalReducers);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [tabSelect, setTabSelect] = useState(location?.state || "free_coupon");
    const listTab = [
        {
            title:"Coupons",
            key:"free_coupon"
        },
        {
            title:"Paid Packages",
            key:"paid_coupon"
        },
       
    ];
    useEffect(()=>{
        // getDonationModel(1, 5000, "all");
        fetchData(1000, 1);
    },[])

    // Get data from api
    // const getDonationModel = async (currentPage,userLimit,userType) => {
    //     const responce = await GetCampaign(accessToken, "", userType, userLimit, currentPage );
    //     if(responce?.status === 200) {
    //         dispatch(setStoreCampaignListOption(responce.data));
    //     } else {
    //         dispatch(setStoreCampaignListOption([]));
    //     };
    // };
      const fetchData = async (userLimit, currentPage) => {
        let url = `${CAMPAIGN_APPROVAL_LIST}/${userLimit}/${currentPage}?method=main`;
        url += `&sort_by=added_by`;
        const response = await GetRequestCallAPI(url, accessToken);
        if (response?.status === 200) {
            const filteredData = response?.data?.data?.filter((item) => item?.is_active && item?.status === "approved")?.reverse();
             dispatch(setStoreCampaignListOption(filteredData));
        } else if (response?.status === 403) {
          CommonLogout();
          dispatch(setStoreCampaignListOption([]));
        } else {
            dispatch(setStoreCampaignListOption([]));
        }
      };
    
    
  return (
    <React.Fragment>
        <ul className="tabcomnsection">
            {listTab?.map((item , index)=>(
                <React.Fragment key={index}>
                    <li className={`${tabSelect == item?.key && "active"} text-capitalized`} onClick={()=>{
                        setTabSelect(item?.key);
                        navigate(PACKAGE_MANAGEMENT, {state: item?.key})
                    }} >
                        {item?.title}
                    </li>
                </React.Fragment>
            ))}
        </ul>
        {tabSelect === "paid_coupon" && (
            <PackageContent/>
        )}
        {tabSelect === "free_coupon" && (
            <FreePackageContent/>
        )}
    </React.Fragment>
  )
}
